module.exports = __webpack_public_path__ + "media/Components/fonts/boldMonda-b8134d4689745c23b760fcbd6e9ae0d9.ttf";